import { PropsWithChildren, useMemo } from 'react';

import { UserGroups } from '../../shared/models/user-groups.enum';
import { User } from '../../shared/models/user.model';
import { AuthenticationContext } from '../contexts/authentication-context';

interface Props extends PropsWithChildren {
   isAuthenticated: boolean;
}

const createMockUser = (): User => ({
   uid: '',
   firstname: 'John',
   lastname: 'Doe',
   name: 'John Doe',
   groups: [UserGroups.ravagoGlobalGroupAdmin],
   sub: '',
   mail: '',
   ravagoCustomerCountryIsoCode: '',
   ravagoCustomerId: 123
});

export const ProducerAuthenticationProviders = ({ isAuthenticated, children }: Props) => {
   const value = useMemo(
      () => ({
         user: isAuthenticated ? createMockUser() : undefined,
         accessToken: isAuthenticated ? 'access-token' : undefined,
         loading: false,
         canAuthenticate: true,
         refreshToken: async () => {
            // no-op
         },
         login: () => {
            // no-op
         },
         logout: () => {
            // no-op
         }
      }),
      []
   );

   return <AuthenticationContext value={value}>{children}</AuthenticationContext>;
};
